import { fetchPhotoSessionDetail } from 'api/photo-session';
import {
  fetchEntryAccess,
  fetchEntryAccessEligibilityList,
} from 'api/entry-access';
import { fetchListingRepresentative } from 'api/listing-representative';
import { USER_TYPE } from './UserInfo/constants';
import {
  FETCH_PHOTO_SESSION_DETAIL,
  PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS,
  PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS,
  PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS,
  PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS,
  PHOTO_SESSION_START_CLICKED_ANALYTICS,
  FETCH_ENTRY_ACCESS,
  PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS,
  FETCH_LISTING_REPRESENTATIVE,
} from './types';

export const fetchPhotoSessionDetailAction = (photoSessionId) => ({
  type: FETCH_PHOTO_SESSION_DETAIL,
  promise: fetchPhotoSessionDetail(photoSessionId),
});

export const photoSessionDetailPageViewedAnalytics = (
  photoSessionId,
  houseId,
  photographerId,
  businessContext,
  currentEntryMethod,
) => ({
  type: PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
    photographerId,
    businessContext,
    currentEntryMethod,
  },
});

export const photoSessionDetailConfirmationClickedAnalytics = ({
  photoSessionId,
  houseId,
  confirmationType,
  ownerId,
  userType = USER_TYPE.OWNER,
}) => ({
  type: PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS,
  extraProperties: {
    job_id: photoSessionId,
    house_id: houseId,
    via: confirmationType,
    owner_id: ownerId,
    user_type: userType,
  },
});

export const photoSessionDetailCallUserClickedAnalytics = ({
  photoSessionId,
  houseId,
  ownerId,
  userType = USER_TYPE.OWNER,
}) => ({
  type: PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS,
  extraProperties: {
    job_id: photoSessionId,
    house_id: houseId,
    owner_id: ownerId,
    user_type: userType,
  },
});

export const photoSessionDetailDirectionsClickedAnalytics = ({
  photoSessionId,
  houseId,
  source,
}) => ({
  type: PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS,
  extraProperties: {
    job_id: photoSessionId,
    house_id: houseId,
    source,
  },
});

export const photoSessionStartClickedAnalytics = ({
  photoSessionId,
  houseId,
}) => ({
  type: PHOTO_SESSION_START_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
  },
});

export const fetchEntryAccessAction = (houseId, journey) => ({
  type: FETCH_ENTRY_ACCESS,
  promise: fetchEntryAccess(houseId, journey),
});

export const fetchEntryAccessEligibilityListAction = (houseId) => ({
  type: FETCH_ENTRY_ACCESS,
  promise: fetchEntryAccessEligibilityList(houseId),
});

export const fetchListingRepresentativeAction = (houseId) => ({
  type: FETCH_LISTING_REPRESENTATIVE,
  promise: fetchListingRepresentative(houseId),
});

export const photoSessionDetailEntryAlertLinkClickedAnalytics = ({
  photoSessionId,
  houseId,
  photographerId,
  currentEntryMethod,
  linkUrl,
}) => ({
  type: PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
    photographerId,
    currentEntryMethod,
    linkUrl,
  },
});
